import { Injectable, Renderer2, RendererFactory2, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { injectConfigs } from '../config/utils';
import { agencyConfigSelector } from '../states/agencyConfig/agencyConfig.selector';

@Injectable({
  providedIn: 'root',
})
export class DomainService {
  private renderer: Renderer2;
  _store = inject(Store);
  agencyConfig$ = this._store.select(agencyConfigSelector);
  DomainInfoList = injectConfigs().DomainInfoList;
  ssoUrl = injectConfigs().endPoints.SSO_URL;
  constructor(
    private title: Title,
    private meta: Meta,
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }
  defaultConfigValue = {
    theme: 'trueconnect',
    primaryColor: '#0eaf8f',
    headerColor:
      'bg-[linear-gradient(90deg,_rgba(237,_28,_36,_0)_-3.46%,_rgb(58,_195,_167)_267.57%),_linear-gradient(0deg,_#fff,_#FFF)]',
    coverImgUrl:
      'https://cdn-test.eztek.net/Eztek/Images/backgound_638175151010149392_ORIGIN.png',
    faviconUrl:
      'https://cdn.eztek.net/Eztek/Images/2022_638261500519744604_ORIGIN.webp',
    seoData: {
      imgUrl:
        'https://cdn.eztek.net/Eztek/Images/2022_638261500519744604_ORIGIN.webp',
      content: 'True Retail domain1 seo content',
      iconUrl:
        'https://cdn.eztek.net/Eztek/Images/2022_638261500519744604_ORIGIN.webp',
    },
  };
  defaultAuthConfig = {
    ...injectConfigs().DefaultAuthConfig,
    redirectUri: window.location.origin,
  };

  tenant(): string {
    const host = location.host;
    const match = host.match(/^([^.]+)-/);
    const tenantFromHost = match ? match[1] : null;
    if (
      !this.DomainInfoList.find((item: any) => item.domain === location.host)
    ) {
      if (tenantFromHost) {
        return tenantFromHost;
      }
    }

    // return "cdp";
    return this.DomainInfoList.find(
      (item: any) => item.domain === location.host
    )?.tenant!;
  }

  client(): string {
    return (
      this.DomainInfoList.find((item: any) => item.domain === location.host)
        ?.client! ?? this.tenant()
    );
  }

  theme(): string {
    return (
      this.DomainInfoList.find((item: any) => item.domain === location.host)
        ?.theme! ?? this.defaultConfigValue.theme
    );
  }
  primaryColor(): string {
    return (
      this.DomainInfoList.find((item: any) => item.domain === location.host)
        ?.primaryColor! ?? this.defaultConfigValue.primaryColor
    );
  }
  headerColor(): string {
    return (
      this.DomainInfoList.find((item: any) => item.domain === location.host)
        ?.headerColor! ?? this.defaultConfigValue.headerColor
    );
  }

  webUrl(): string {
    return window.location.origin;
  }

  // registerUrl(): string {
  //   return this.DomainInfoList.find((item:any) => item.domain === location.host)
  //     ?.registerUrl!;
  // }

  activatedCardUrl(): string {
    const url = this.ssoUrl + '/Manage/ActivatedCard?s=' + this.tenant();
    return url;
  }

  coverImgUrl(): string {
    return (
      this.DomainInfoList.find((item: any) => item.domain === location.host)
        ?.coverImg! ?? this.defaultConfigValue.coverImgUrl
    );
  }

  metaDesContent(): string {
    return (
      this.DomainInfoList.find((item: any) => item.domain === location.host)
        ?.seoData.content! ?? this.defaultConfigValue.seoData.content
    );
  }

  metaIconUrl(): string {
    return (
      this.DomainInfoList.find((item: any) => item.domain === location.host)
        ?.seoData.iconUrl! ?? this.defaultConfigValue.seoData.iconUrl
    );
  }

  metaImgUrl(): string {
    return (
      this.DomainInfoList.find((item: any) => item.domain === location.host)
        ?.seoData.imgUrl! ?? this.defaultConfigValue.seoData.imgUrl
    );
  }

  metaTag() {
    this.agencyConfig$.subscribe((data: any) => {
      let faviconUrl: any;
      if (data?.logo) {
        faviconUrl = data.logo;
      } else {
        faviconUrl =
          this.DomainInfoList.find((item: any) => item.domain === location.host)
            ?.seoData.iconUrl! ?? this.defaultConfigValue.faviconUrl;
      }
      let titleApp: string = '';
      if (data?.shortName) {
        titleApp = data?.shortName!;
      } else {
        titleApp = this.DomainInfoList.find(
          (item: any) => item.domain === location.host
        )?.webTitle!;
      }
      // this.meta.updateTag({ name: 'description', content: data.description });
      this.meta.updateTag({ property: 'og:title', content: titleApp });
      // this.meta.updateTag({ property: 'og:description', content: data.description });
      this.meta.updateTag({ property: 'og:image', content: faviconUrl });
      this.meta.updateTag({ property: 'twitter:image', content: faviconUrl });

      this.meta.updateTag({ property: 'og:site_name', content: titleApp });
    });
  }

  // webTitle(): string {
  //   return this.DomainInfoList.find((item:any) => item.domain === location.host)
  //     ?.webTitle!;
  // }

  // setWebTitle() {
  //   const webtitle = this.DomainInfoList.find(
  //     (item:any) => item.domain === location.host
  //   )?.webTitle!;
  //   this.title.setTitle(webtitle);
  // }

  setWebTitle() {
    const webtitle = this.DomainInfoList.find(
      (item: any) => item.domain === location.host
    )?.webTitle!;
    if (webtitle && webtitle !== '') {
      this.agencyConfig$.subscribe((data) => {
        this.title.setTitle(webtitle);
      });
    } else {
      this.agencyConfig$.subscribe((data) => {
        this.title.setTitle(data?.shortName!);
      });
    }
  }

  setFavicon() {
    this.agencyConfig$.subscribe((data: any) => {
      let faviconUrl: any;
      if (data?.logo) {
        faviconUrl = data.logo;
      } else {
        faviconUrl =
          this.DomainInfoList.find((item: any) => item.domain === location.host)
            ?.seoData.iconUrl! ?? this.defaultConfigValue.faviconUrl;
      }
      const appFavicon = document.querySelectorAll('.appFavicon');
      if (appFavicon.length) {
        appFavicon.forEach((e: any) => {
          e?.setAttribute('href', faviconUrl);
        });
      }
      let link: HTMLLinkElement =
        document.querySelector("link[rel~='icon']") ||
        this.renderer.createElement('link');
      link.rel = 'icon';
      link.href = faviconUrl;
      link.type = 'image/png';
      this.renderer.appendChild(document.head, link);
    });
  }
  setFavicon2() {
    let faviconUrl;
    this.agencyConfig$.subscribe((data: any) => {
      if (data?.logo) {
        faviconUrl = data.logo;
      } else {
        faviconUrl =
          this.DomainInfoList.find((item: any) => item.domain === location.host)
            ?.seoData.iconUrl! ?? this.defaultConfigValue.faviconUrl;
      }
    });
    return faviconUrl;
  }

  setMeta1(content: string, property: string) {
    this.meta.updateTag({ content: content, property: property });
  }

  setMeta2(name: string, content: string) {
    this.meta.updateTag({ name: name, content: content });
  }

  getAuthConfig(): any {
    return (
      this.DomainInfoList.find((item: any) => item.domain === location.host)
        ?.authConfig! ?? this.defaultAuthConfig
    );
  }
  loadManifest() {
    let titleApp: string = '';
    this.agencyConfig$.subscribe((data: any) => {
      let faviconUrl: any;
      if (data?.logo) {
        faviconUrl = data.logo;
      } else {
        faviconUrl =
          this.DomainInfoList.find((item: any) => item.domain === location.host)
            ?.seoData.iconUrl! ?? this.defaultConfigValue.faviconUrl;
      }

      if (data?.shortName) {
        titleApp = data?.shortName!;
      } else {
        titleApp = this.DomainInfoList.find(
          (item: any) => item.domain === location.host
        )?.webTitle!;
      }
      // Tạo dữ liệu manifest động
      const manifestData = {
        name: titleApp,
        short_name: titleApp,
        icons: [
          {
            src: faviconUrl,
            sizes: '192x192',
            type: 'image/png',
          },
          {
            src: faviconUrl,
            sizes: '512x512',
            type: 'image/png',
          },
        ],
        start_url: '/',
        display: 'standalone',
        background_color: '#ffffff',
        theme_color: '#000000',
      };

      // Tạo file JSON từ object
      const blob = new Blob([JSON.stringify(manifestData)], {
        type: 'application/json',
      });
      const manifestURL = URL.createObjectURL(blob);

      // Thêm thẻ `<link rel="manifest">` vào `<head>`
      let manifestElement =
        document.querySelector("link[rel='manifest']") ||
        this.renderer.createElement('link');
      manifestElement.setAttribute('rel', 'manifest');
      manifestElement.setAttribute('href', manifestURL);
      this.renderer.appendChild(document.head, manifestElement);
    });
  }
}
